import React, { Component } from 'react';
import './logo.scss';
import imgLogo from '../../assets/images/logo.png';

class Logo extends Component{
    render(){
        return (
            <img className={this.props.propClassName} src={imgLogo} alt="" width="110" height="28" />
        )
    }
}

export default Logo;
